import type { RecursiveRequired, Settings } from '#/global'
import { cloneDeep } from 'es-toolkit'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'

const globalSettings: Settings.all = {
  // 请在此处编写或粘贴配置代码
  tabbar: {
    list: [
      {
        path: '/',
        icon: 'i-ic:sharp-home',
        activeIcon: 'i-ic:twotone-home',
        text: '首页',
      },
      {
        path: '/selected/',
        icon: 'material-symbols:add-box-outline-rounded',
        activeIcon: 'material-symbols:add-box-outline-rounded',
        text: '自选',
      },
      {
        path: '/market/',
        icon: 'material-symbols:broken-image-outline',
        activeIcon: 'material-symbols:broken-image-outline',
        text: '行情',
      },
      {
        path: '/user/',
        icon: 'i-ic:baseline-person',
        activeIcon: 'i-ic:twotone-person',
        text: '我的',
      },
    ],
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
